export const LASTREADING_REQUEST_DETAILS_OPEN_MODAL = "LASTREADING_REQUEST_DETAILS_OPEN_MODAL";
export const LASTREADING_REQUEST_DETAILS_REQUEST = "LASTREADING_REQUEST_DETAILS_REQUEST";
export const LASTREADING_REQUEST_DETAILS_RESULT = "LASTREADING_REQUEST_DETAILS_RESULT";